import { render, staticRenderFns } from "./TableSerialList.vue?vue&type=template&id=710a7b4a&scoped=true&"
import script from "./TableSerialList.vue?vue&type=script&lang=js&"
export * from "./TableSerialList.vue?vue&type=script&lang=js&"
import style0 from "./TableSerialList.vue?vue&type=style&index=0&id=710a7b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710a7b4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VChip,VDataTable,VDialog,VImg})
